// extracted by mini-css-extract-plugin
module.exports = {"alert":"Alert_alert__vspl0","alertInfo":"Alert_alertInfo__w5M85"};